import { translationKey } from '@change-corgi/core/i18n';

import iconsAboutBusinessModelSunrise from '#src/app/pages/about/main/shared/assets/icons-about-business-model-sunrise.png';
import iconsAboutDecisionMakerSunrise from '#src/app/pages/about/main/shared/assets/icons-about-decision-maker-sunrise.png';
import iconsAboutMediaSunrise from '#src/app/pages/about/main/shared/assets/icons-about-media-sunrise.png';
import iconsAboutOpenPlatformSunrise from '#src/app/pages/about/main/shared/assets/icons-about-open-platform-sunrise.png';
import iconsAboutOrganizationSunrise from '#src/app/pages/about/main/shared/assets/icons-about-organization-sunrise.png';
import iconsAboutUserSunrise from '#src/app/pages/about/main/shared/assets/icons-about-user-sunrise.png';
import type { HowWorksListType, InfoCardLinkType, WhoUsesCardType } from '#src/app/pages/about/main/shared/types';

// IMAGES
export const OG_IMAGE: string = '/brand-pages/about/opengraph-about.jpg';

// STATIC DATA

export const WHO_USES_LIST: WhoUsesCardType[] = [
	{
		icon: iconsAboutUserSunrise,
		title: translationKey('fe.pages.about.section_users.user1.title'),
		description: translationKey('fe.pages.about.section_users.user1.description'),
	},
	{
		icon: iconsAboutDecisionMakerSunrise,
		title: translationKey('fe.pages.about.section_users.user2.title'),
		description: translationKey('fe.pages.about.section_users.user2.description'),
	},
	{
		icon: iconsAboutOrganizationSunrise,
		title: translationKey('fe.pages.about.section_users.user3.title'),
		description: translationKey('fe.pages.about.section_users.user3.description'),
	},
	{
		icon: iconsAboutMediaSunrise,
		title: translationKey('fe.pages.about.section_users.user4.title'),
		description: translationKey('fe.pages.about.section_users.user4.description'),
	},
];

export const INFO_CARD_LINKS: InfoCardLinkType[] = [
	{
		to: '/about/open',
		icon: iconsAboutOpenPlatformSunrise,
		title: translationKey('fe.pages.about.section_open_platform.header'),
		description: translationKey('fe.pages.about.section_open_platform.description'),
	},
	{
		to: '/about/business-model',
		icon: iconsAboutBusinessModelSunrise,
		title: translationKey('fe.pages.about.section_business_model.header'),
		description: translationKey('fe.pages.about.section_business_model.description'),
	},
];

export const HOW_WORKS_LIST: HowWorksListType[] = [
	{
		title: translationKey('fe.pages.about.section_campaign.step1.title'),
		description: translationKey('fe.pages.about.section_campaign.step1.description'),
	},
	{
		title: translationKey('fe.pages.about.section_campaign.step2.title'),
		description: translationKey('fe.pages.about.section_campaign.step2.description'),
	},
	{
		title: translationKey('fe.pages.about.section_campaign.step3.title'),
		description: translationKey('fe.pages.about.section_campaign.step3.description'),
	},
	{
		title: translationKey('fe.pages.about.section_campaign.step4.title'),
		description: translationKey('fe.pages.about.section_campaign.step4.description'),
	},
	{
		title: translationKey('fe.pages.about.section_campaign.step5.title'),
		description: translationKey('fe.pages.about.section_victories.description'),
	},
];
